import { render, staticRenderFns } from "./FormProposal.vue?vue&type=template&id=22e51b90"
import script from "./FormProposal.vue?vue&type=script&lang=js"
export * from "./FormProposal.vue?vue&type=script&lang=js"
import style0 from "./FormProposal.vue?vue&type=style&index=0&id=22e51b90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports